// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__iXsij","pending":"StatusBadge_pending__rp6dE","picking":"StatusBadge_picking__z69Bp","packed":"StatusBadge_packed__uWY3P"};